import moment from "moment"

export const verificarDataLabel = (inicio: string | null | undefined, fim: string | null | undefined, formatString: string = 'DD/MM/YYYY') => {
    const inicial = inicio ? moment(inicio, 'YYYY-MM-DD') : null
    const final = fim ? moment(fim, 'YYYY-MM-DD') : null
    let placeholderInput = ""
    if (inicial && final) placeholderInput = `${inicial.format(formatString)} até ${final.format(formatString)}`
    if (inicial || final) {
        if (!inicial) placeholderInput = `até ${final?.format(formatString)}`
        if (!final) placeholderInput = `a partir de ${inicial?.format(formatString)}`
    }
    if (!inicial && !final) placeholderInput = 'Todos'

    return placeholderInput;
}